import { Exclude, Type } from 'class-transformer';
import { DimensionOptionCodeRawDto } from '../../../shared-cirabooks-module/_models/common/dimensions/dimension-option-code-raw-dto';

export class GLJournalItemRawDto {
    crudAction: string;
    glJournalItemId: number;
    glJournalId: number;
    glAccountNumber: string;
    subCategoryCode: string;
    debitOrCreditCode: string; // Required
    amount: number; // Required

    description: string;

    @Type(() => DimensionOptionCodeRawDto)
    dimensions: DimensionOptionCodeRawDto[]; // 	Required

    // Transient Fields
    @Exclude()
    itemId: number;
    @Exclude()
    credit: number;
    @Exclude()
    debit: number;
    @Exclude()
    subCategorySource: any[];
}
